/*
  menu-items-host.js

  2025-12-23: Removed Dashboard from Host menu (CRM is now landing page)
  2025-12-23: Added Automation menu with Automated Rules and Automated Messages submenu items
  2025-12-23: Simplified menu structure with core items: Onboarding, BAM Chat, Dashboard, CRM, Multi Calendar, Automation, Configuration
  2025-12-21: Added value_v2 URLs and keys for all menu items to support React app navigation
*/
const menuItemsHost = [
  {
    key: 'onboarding',
    text: 'Onboarding',
    description: 'Quick start guide and setup wizard',
    allowed_roles: ['admin', 'host', 'property-manager', 'coordinator'],
    icon: 'mdi-rocket-launch-outline',
    value: '/dashboard/setup',
    value_v2: `/app/setup`,
  },
  {
    key: 'bam_chat',
    text: 'BAM Chat',
    description: 'AI-powered chat assistant for property management',
    requiresBamAccess: true,
    icon: 'mdi-robot-outline',
    value_v2: `/app/bam-chat`,
  },
  {
    key: 'crm',
    text: 'CRM',
    description: 'Customer relationship management and guest interactions',
    allowed_roles: ['admin', 'host', 'property-manager', 'coordinator'],
    module: 'comm',
    abilities: ['crm-management', 'crm:view'],
    abilityOrRole: true,
    icon: 'mdi-account-outline',
    value: '/dashboard/guest-experience',
    value_v2: `/app/crm`,
  },
  {
    key: 'multi_calendar',
    text: 'Multi Calendar',
    description: 'View availability across your properties',
    allowed_roles: ['admin', 'host', 'property-manager', 'coordinator'],
    icon: 'mdi-calendar-multiselect',
    value: '/dashboard/multi-calendar',
    value_v2: `/app/calendar`,
  },
  {
    key: 'automation',
    text: 'Automation',
    description: 'Automated workflows and communications',
    icon: 'mdi-robot-outline',
    submenu: [
      {
        key: 'automation_rules',
        text: 'Automated Rules',
        description: 'Configure automated task rules and triggers',
        allowed_roles: ['admin', 'host', 'property-manager'],
        icon: 'mdi-cog-sync-outline',
        value: '/dashboard/auto-tasks',
        value_v2: `/app/auto-task-rules`,
      },
      {
        key: 'automation_messages',
        text: 'Automated Messages',
        description: 'Configure automated guest communications',
        allowed_roles: ['admin', 'host', 'property-manager', 'coordinator'],
        icon: 'mdi-message-processing-outline',
        value: '/dashboard/auto-messages',
        value_v2: `/app/guests/automated-messages`,
      },
    ],
  },
  {
    key: 'configuration',
    text: 'Configuration',
    description: 'System configuration and settings',
    icon: 'mdi-cog-outline',
    submenu: [
      {
        key: 'configuration_settings',
        text: 'Settings',
        description: 'General system settings and user management',
        allowed_roles: ['admin', 'host', 'property-manager'],
        icon: 'mdi-cog-outline',
        value: '/dashboard/management',
        value_v2: `/app/dashboard/management`,
      },
      {
        key: 'configuration_ai',
        text: 'AI',
        description: 'AI assistant settings and policies',
        allowed_roles: ['admin', 'host'],
        abilities: ['ai-config'],
        module: 'ai',
        icon: 'mdi-brain',
        value: '/dashboard/ai-config',
        value_v2: `/app/ai-config`,
      },
    ],
  },
]

export default menuItemsHost
